<template>
  <div class="container">
    <div class="row overall-padding">
      <div class="col-12">
        <div class="row mb-3">
          <div class="col-3">
            <div>
              <img
                class="w-100 h-100"
                src="https://cdn.discordapp.com/attachments/694122695930937427/910484888627593276/mock-d1.png"
              >
            </div>
          </div>
          <div class="col-3">
            <div>
              <img
                class="w-100 h-100"
                src="https://cdn.discordapp.com/attachments/694122695930937427/910484882017353788/mock-d2.png"
              >
            </div>
          </div>
          <div class="col-3">
            <div>
              <img
                class="w-100 h-100"
                src="https://cdn.discordapp.com/attachments/694122695930937427/910484883615395921/mock-d3.png"
              >
            </div>
          </div>
          <div class="col-3">
            <div>
              <img
                class="w-100 h-100"
                src="https://cdn.discordapp.com/attachments/694122695930937427/910484885255389215/mock-d4.png"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
}
</script>

<style></style>
